import React from 'react';
import {TextInternalEntity} from '~/types';
import {Text} from '~/components/elements';
import {DATA_TEST_IDS} from '~/lib/const';

// Wrapper class for Text to work with TextInternal entity on Sanity
export function TextInternal(props: TextInternalEntity & {className?: string}) {
  const {
    text,
    variant,
    fontSize,
    lineHeight,
    color,
    colorOption,
    fontWeightOption,
    className,
  } = props;

  // inline style because the values comes from Sanity
  const style = {
    fontSize: fontSize && `${fontSize}px`,
    lineHeight: lineHeight && `${lineHeight}px`,
    color: color ?? colorOption,
    fontWeight: fontWeightOption,
  };

  return (
    <Text
      testid={DATA_TEST_IDS.TEXT_INTERANL}
      as={variant}
      className={className}
      style={style}
    >
      {text}
    </Text>
  );
}
